import VirtualMirror from '../components/virtualMirror';

export default VirtualMirror;